import { Component, Input, OnChanges } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd';
/**
 * fc-modalinputè¾å¥æ¡æ¨¡ææ¡
 * 
 * æ¨¡ææ¡ä¸­æä¸ä¸ªè¾å¥æ¡ç»ä»¶ã
 * 
 * æ¯å¦ä¿®æ¹å¯ç ãä¿®æ¹ç¨æ·åæ¶ï¼éè¦å¼¹çªæ¡åæä¸ä¸ªè¾å¥æ¡ç»ä»¶æ¶ã
 * 
 */
@Component({
    selector: 'fc-modalinput',
    template: `
    <fc-text  [(ngModel)]="_content"></fc-text>
    <div class="customize-footer">
        <fc-button  [fcType]="'primary'" fcLabel="ç¡®å®" (click)="ok($event)">
        </fc-button>
        <fc-button [fcType]="'default'" fcLabel="åæ¶"  (click)="cancel($event)">
        </fc-button>
    </div>
    `,
    styles: [`
    .customize-footer{
        text-align:right;
    }
    `]
})
export class FcmodalinputComponent {
     /**è¾å¥çåå®¹*/
    _content: string | number;
     /**å¼¹çªåçå¼ä¼ åº*/
    @Input()
    set options(option: any) {
        this._content = option.content;
    }
    constructor(private modal: NzModalRef) {

    }
    /**
     * ç¡®å®
     */
    ok(event): void {
         /**æinputæ¡å¡«åçåå®¹ä¼ åº*/
        this.modal.destroy({ data: this._content });
    }
    /**
     * åæ¶
     */
    cancel(event): void {
        this.modal.destroy();
    }
}
